var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("PAGINA NON DISPONIBILE")]),_c('v-card-text',[_c('p',[_vm._v("La pagina selezionata non è al momento disponibile")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }